import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

class Size {
  create = async (size: any) => {
    const res = await axios.post<any>(`${API_URL}item-size`, size)
      .catch((e) => {
        const { message } = res.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
    return res.data;
  };

  edit = async (size: any, code: any) => {
    await axios.put<any>(`${API_URL}item-size/${code}`, size)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  get = async (code: any) => {
    const response = await axios.get<any>(`${API_URL}item-size/${code}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.size;
  };

  getAll = async () => {
    const response = await axios.get<any>(`${API_URL}item-size`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.size;
  };
}

export default new Size();
